import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const SearchBarContainer = styled.div<{ $mobileOpen?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-bottom: 0.3rem;
  flex-shrink: 0; /* Prevent search bar from shrinking */

  @media (max-width: 768px) {
    display: ${({ $mobileOpen }) => ($mobileOpen ? 'flex' : 'none')};
    position: relative;
    flex-direction: column;
    gap: 0.5rem;
    margin: 0 0.25rem 0.5rem;
    padding: 0.6rem;
    border: 1px solid var(--border);
    border-radius: 10px;
    background: var(--surface);
    box-shadow: 0 8px 24px var(--shadow);
  }
`;

export const MobileCloseSearchButton = styled.button`
  display: none;

  @media (max-width: 768px) {
    position: absolute;
    top: 0.72rem;
    right: 0.72rem;
    z-index: 2;
    display: inline-flex;
    width: 36px;
    height: 36px;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: var(--text-secondary);
    cursor: pointer;
    font-size: 1.35rem;
  }
`;

export const SearchInputWrapper = styled.div`
  flex: 1 1 24rem;
  min-width: 14rem;
  position: relative;

  @media (max-width: 768px) {
    flex: 0 1 auto;
    width: 100%;
    min-width: 0;
    padding-right: 2.7rem;
  }

  input {
    width: 100%;
    background: var(--surface);
    color: var(--text);
    border: 1px solid var(--border);
    border-radius: 8px;
    padding: 0.48rem 2.2rem 0.48rem 0.75rem;
    font-size: 0.86rem;
    line-height: 1.3;
    box-shadow: 0 2px 8px var(--shadow);
  }

  input:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary) 22%, transparent);
  }

  @media (max-width: 768px) {
    input {
      min-height: 44px;
      padding-block: 0.65rem;
    }
  }
`;

export const InlineControls = styled.div`
  display: flex;
  align-items: center;
  flex: 0 1 auto;
  min-width: 0;

  > * {
    margin-bottom: 0 !important;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const AddEventButton = styled(Link)`
  width: auto;
  min-width: 7.25rem;
  border: 1px solid var(--border);
  font-weight: 700;
  text-decoration: none;
  padding: 0.48rem 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--primary);
  color: #ffffff;
  border-radius: 8px;
  font-size: 0.88rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px var(--shadow);
  
  &:hover {
    text-decoration: none;
    background-color: var(--primary-hover);
    color: white;
    transform: translateY(-1px);
  }

  @media (max-width: 768px) {
    width: 100%;
    min-height: 44px;
    padding: 0.75rem 1rem;
    margin-top: 0;
  }
`;

export const ClearSearchButton = styled.button`
  position: absolute;
  top: 50%;
  right: 0.45rem;
  transform: translateY(-50%);
  width: 1.7rem;
  height: 1.7rem;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: color-mix(in srgb, var(--primary) 12%, transparent);
    color: var(--text);
  }
`;
